import React, { useState, useEffect } from 'react';
import ClearIcon from '@material-ui/icons/Clear';
import { useDispatch } from 'react-redux';
import { EmailRecoveryModal } from '../EmailRecoveryModal';

import {
  FormContainer,
  LoginTitle,
  LoginSubTitle,
  SignInButton,
  FirstAccessContainer,
} from './styles';

export function InvalidEmail({ isMFA }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const handleBeforeUnload = () => {
      dispatch({ type: 'SET_STEP', step: 0 });
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const InvalidEmailContent = () => (
    <>
      <LoginTitle className="mb-3">
        E-mail inválido
        <ClearIcon style={{ color: '#E8454F', fontSize: '30px' }} />
      </LoginTitle>
      <LoginSubTitle className="mb-3">
         Verifique o e-mail com o titular da conta e tente novamente.
      </LoginSubTitle>
      <SignInButton
        type="submit"
        className="mt-4"
        onClick={() => {
          if(isMFA) {
            dispatch({ type: 'SET_STEP', step: 0 });
          } else {
            dispatch({ type: 'SET_STEP', step: 10 });
          }
        }}
      >
        <span>Voltar para o início</span>
      </SignInButton>

      <FirstAccessContainer
        className="mt-3 w-100"
        onClick={handleOpenModal}
      >
        <SignInButton outline>
          <span>Contatar SAP para obter ajuda</span>
        </SignInButton>
      </FirstAccessContainer>
    </>
  );

  useEffect(() => {
    const handleBeforeUnload = () => {
      dispatch({ type: 'SET_STEP', step: 0 });
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <>
      {isModalOpen && <EmailRecoveryModal handleClose={handleCloseModal} />}
      {isMFA ? (
        <FormContainer>
          <InvalidEmailContent />
        </FormContainer>
      ) : (
        <InvalidEmailContent />
      )}
    </>
  );
}
